import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Modal, Input, Form } from 'antd'
import Button from 'components/button/Button'
import { IconCancel } from 'components/icons'
import { phoneInputValidation, phonePasteValidation } from 'helpers/validation'
import {AdminsOrdersDeliveriesUpdateRequest} from 'generated/api'

interface IProps {
  loading: boolean
  visibility: boolean
  initialValue: AdminsOrdersDeliveriesUpdateRequest
  onCancel: () => void
  onAccept: (payload: AdminsOrdersDeliveriesUpdateRequest) => void
}

function ModalChangePickUp(props: IProps) {
  const { initialValue, onAccept, onCancel, visibility, loading } = props
  const regexPattern = '^[A-Z]{1,2}\\d{1,4}[A-Z]{0,3}';
  const regex = new RegExp(regexPattern);

  const validationSchema = Yup.object({
    recipientName: Yup.string()
      .required('Mohon isi nama Penjemput')
      .max(100, 'Maksimal 100 Karakter'),
    recipientPhoneNo: Yup.string()
      .required('Mohon isi Nomor Telepon Penjemput')
      .min(9, 'Nomor telepon minimal 9 Digit'),
    vehicleLicenseNo: Yup.string()
      .required('Mohon isi Plat Nomor Kendaraan')
      .test('vehicleLicenseNo', 'Plat Nomor Kendaraan tidak valid', (value) => {
        if (value) {
          return regex.test(value)
        }
        return true
      })
  })

  return (
    <Modal
      data-testid="modal_change_pickup"
      centered
      closable={!loading}
      onCancel={onCancel}
      open={visibility}
      footer={null}
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
      title="Ubah Penjemput"
    >
      <div className="flex flex-col">
        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          validateOnMount={false}
          onSubmit={(values) => onAccept(values)}
        >
          {({ values,
              handleChange,
              handleSubmit,
              touched,
              errors,
          }) => (
            <Form
              data-testid="input_change_pickup"
              layout="vertical"
              className="formdasdas"
              onFinish={handleSubmit}
            >
              <div className="my-4">
                <Form.Item name="recipientName" label="Nama Penjemput" className="font-bold text-xs" initialValue={initialValue.recipientName}>
                  <Input
                    data-testid="input_change_pickup_recipient_name"
                    disabled={loading}
                    className={`focus:border-primary border rounded-xl px-4 py-3 ${errors.recipientName && touched.recipientName ? 'border-danger': 'border-[#C5C6CC]'}`}
                    value={values.recipientName}
                    onChange={handleChange('recipientName')}
                    placeholder="Contoh: Herman"
                  />
                </Form.Item>
                {errors.recipientName && touched.recipientName  ? (<div className="-mt-5">
                  <p className="mt-1 text-sm italic text-danger">{errors.recipientName}</p>
                </div>) : null}
              </div>
              <div className="my-4">
                <Form.Item name="recipientPhoneNo" label="Nomor Handphone" className="font-bold text-xs" initialValue={initialValue.recipientPhoneNo}>
                  <Input
                    data-testid="input_change_pickup_recipient_phone_no"
                    onKeyDown={(event) => phoneInputValidation(event, values.recipientPhoneNo, 13)}
                    onPaste={(e) => phonePasteValidation(e, values.recipientPhoneNo, 13)}
                    disabled={loading}
                    className={`focus:border-primary border rounded-xl px-4 py-3 ${errors.recipientPhoneNo && touched.recipientPhoneNo ? 'border-danger': 'border-[#C5C6CC]'}`}
                    value={values.recipientPhoneNo}
                    onChange={handleChange('recipientPhoneNo')}
                    placeholder="Contoh: 081213676567"
                  />
                </Form.Item>
                {errors.recipientPhoneNo && touched.recipientPhoneNo ? (<div className="-mt-5">
                  <p className="mt-1 text-sm italic text-danger">{errors.recipientPhoneNo}</p>
                </div>) : null}
              </div>
              <div className="my-4">
                <Form.Item name="vehicleLicenseNo" label="Plat Nomor Kendaraan" className="font-bold text-xs" initialValue={initialValue.vehicleLicenseNo}>
                  <Input
                    data-testid="input_change_pickup_vehicle_license_no"
                    disabled={loading}
                    className={`focus:border-primary border rounded-xl px-4 py-3 ${errors.vehicleLicenseNo && touched.vehicleLicenseNo ? 'border-danger': 'border-[#C5C6CC]'}`}
                    value={values.vehicleLicenseNo}
                    onChange={handleChange('vehicleLicenseNo')}
                    placeholder="Contoh: BM 1 WJX"
                  />
                </Form.Item>
                {errors.vehicleLicenseNo && touched.vehicleLicenseNo ? (<div className="-mt-5">
                  <p className="mt-1 text-sm italic text-danger">{errors.vehicleLicenseNo}</p>
                </div>) : null}
              </div>
              <Button
                type="submit"
                data-testid="btn_submit_change_pickup"
                loading={loading}
                disabled={loading}
                block={true}
                onClick={() => handleSubmit}
                className=" pt-3 rounded-xl pb-3 font-bold text-sm"
                label="SIMPAN"
                variant="solid-primary"
              />
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default ModalChangePickUp